import React, { useEffect, useRef, useState } from 'react';
import './AudioPlayer.scss'
import play from '../../assets/images/CommonComponent/play.svg';
import pause from '../../assets/images/CommonComponent/pause.svg';
import { getDataFromFirebase } from '../../Config/commonFirebaseImage';
import { Skeleton } from '@mui/material';

const AudioPlayer  = ({ path, url, thumbnilPath, thumbnialURL, audioDuration, width, height})=>{
    const [currentTime, setCurrentTime] = useState(['00','00', '00']);
    const [currentTimeSec, setCurrentTimeSec] = useState(0); 
    const [duration, setDuration] = useState([0, 0]); 
    const [durationSec, setDurationSec] = useState(); 
    const [audioStatus, changeAudioStatus] = useState(false);
    const [firebaseURL, setFirebaseURL] = useState(url)
    const [firebaseThumbnialURL, setFirebaseThumbnialURL] = useState(thumbnialURL)
    const [loading, setLoading] = useState(true)
    
    const myRef = useRef();

    const startPauseAudio = () => {
        if(audioStatus){
            myRef.current.pause();
            changeAudioStatus(false);
        }else{
            myRef.current.play();
            changeAudioStatus(true);
        }
    
    };


    const sec2Min = (sec) => {
        const hour = Math.floor(sec / 3600 );
        const min = Math.floor(sec % 3600 / 60);
        const secRemain = Math.floor(sec %3600 % 60);
        return {
            hour: hour?.toString()?.padStart(2, '0'),
            min: min?.toString()?.padStart(2, '0'),
            sec: secRemain?.toString()?.padStart(2, '0'),
        };
      };


      
    const getURL= async(path)=>{
        return await getDataFromFirebase(path) || ""
    }

    const setURLs = async()=>{
        if(path){
            setFirebaseURL(await getURL(path))
        }
        if(thumbnilPath){
            setFirebaseThumbnialURL(await getURL(thumbnilPath))
        }
        setLoading(false)
    }

    useEffect(() => {
        const { hour, min, sec } = sec2Min(myRef.current?.duration);
        setDurationSec(myRef.current.duration);
        setDuration([hour, min, sec]);

        let durationData = audioDuration?.split(':')
        setDuration([durationData?.[0], durationData?.[1], durationData?.[2]]);
        let interval;

        if(audioStatus){
            interval = setInterval(() => {
              const {hour, min, sec } = sec2Min(myRef.current.currentTime);
              console.log(currentTime);
              setCurrentTimeSec(myRef.current.currentTime);
              setCurrentTime([hour, min, sec]);
            }, 1000);
        }
    

        return () => clearInterval(interval);
      }, [audioStatus]);

      useEffect(()=>{
        if(`${currentTime[0]}:${currentTime[1]}:${currentTime[2]}` === `${duration[0]}:${duration[1]}:${duration[2]}`)
            changeAudioStatus(false)
      }, [currentTime])

      useEffect(()=>{
            setURLs()
        }, [path])

        
    useEffect(()=>{
        myRef?.current?.addEventListener("ended", (event) => {
            changeAudioStatus(false);
        })
    }, [])

    return (
        <div style={{width: '600px', textAlign: 'center', margin: '20px 0'}}>
            <div className='text-center'>
            {
                loading ? <Skeleton variant="rounded" className='mx-auto' width={width || "140px"} height={height || "140px"} />:
                firebaseThumbnialURL &&
                <div className='position-relative mx-auto' style={{width: 'fit-content'}}>
                        <img className="mainIcon" src={firebaseThumbnialURL} alt="" width="140px" height="140px" />
                    <img className="view-videoPlayIcon" src={audioStatus ? pause : play} onClick={startPauseAudio} alt="" width="35px" height="35px" />
                </div>
            }
                <div>
                    <div className='slider flex items-center'>
                        <img className="mr-2" src={audioStatus ? pause : play} onClick={startPauseAudio} alt="" width="20px" height="20px" />
                        <div className='mr-3'>{currentTime[0]}:{currentTime[1]}:{currentTime[2]} / {duration[0]}:{duration[1]}:{duration[2]}</div>
                        <input
                            type="range"
                            min="0"
                            step={0.001}
                            max={durationSec}
                            default="0"
                            value={currentTimeSec}
                            className="timeline"
                            onChange={(e) => {
                                myRef.current.currentTime = e.target.value;
                            }}
                        />
                    </div>
                </div>
            </div>
            <audio className='d-none'  src={firebaseURL} ref={myRef} width="600" type="audio/mp3">
            </audio>
        </div>

    )
}

export default AudioPlayer;